import React from "react";
import { NO_ACCESS_TITLE } from "../constants/labelConstants";
import StatusText, { STATUS_TEXT_STATUS_OPTIONS } from "./StatusText";

function NoAccessStatusText() {
  return <StatusText status={STATUS_TEXT_STATUS_OPTIONS.WARNING}>{NO_ACCESS_TITLE}</StatusText>;
}

export default NoAccessStatusText;
